<template>
  <LcBadge v-bind="config[status]">
    {{ $t(`myorders.status.scratchcard.${status}`) }}
  </LcBadge>
</template>

<script lang="ts" setup>
import type { LcIconName } from '@lottocom/frontend-components'

import { ScratchcardState } from '#api/shared/@types/generated/backend/graphql-schema-types'

type MyOrdersStatusBadgeScratchcardProps = {
  count?: number
  status: ScratchcardState
}

type StatusBadge = {
  class: string
  icon: LcIconName
}

const props = defineProps<MyOrdersStatusBadgeScratchcardProps>()

const config = computed<Record<ScratchcardState, StatusBadge>>(() => ({
  [ScratchcardState.Cancelled]: {
    class: 'bg-accent-danger-danger',
    icon: 'orders-canceled',
  },
  [ScratchcardState.InProgress]: {
    class: 'bg-secondary-secondary-bold',
    icon: 'orders-waiting-for-purchase',
  },
  [ScratchcardState.Purchased]: {
    class: 'bg-secondary-secondary-bold',
    icon: 'orders-waiting-for-purchase',
  },
  [ScratchcardState.Revealed]: {
    class: 'secondary300',
    icon: 'bell',
  },
  [ScratchcardState.Scratched]: {
    class: 'bg-secondary-secondary',
    count: props.count,
    icon: 'scratch-now',
  },
}))
</script>
